import React from "react"
import { Link } from "react-router-dom"

import "../styles/subterrafors.css"
import StyledBorderView from "../components/StyledBorderView"

const SubterraFors = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  document.title = "Subterra Fors | A Solitaire Dungeon Card Game"

  const baseUrl = process.env.PUBLIC_URL || ""

  return (
    <div className="subterrafors-page">
      {/* Hero – fixed, stays in place */}
      <section className="sf-hero">
        <div className="sf-hero-icon-wrap">
          <img
            src={`${baseUrl}/assets/subterra-fors-assets/images/icon.png`}
            alt="Subterra Fors"
            className="sf-hero-icon"
          />
        </div>
        <h1 className="sf-hero-title">Subterra Fors</h1>
        <p className="sf-tagline">A solitaire dungeon, one card at a time.</p>
        <StyledBorderView
          borderFolder="border"
          className="sf-cta"
          contentStyle={{
            padding: "calc(12px + 0.75rem) calc(12px + 1.75rem)",
          }}
        >
          Coming Soon
        </StyledBorderView>
      </section>

      {/* Scroll content – scrolls over the hero */}
      <div className="sf-scroll-content">
        <div className="sf-hero-spacer" aria-hidden="true" />
        {/* Gameplay overview */}
        <section className="sf-section">
        <h2 className="sf-section-title sf-section-title-centered">
          How it works
        </h2>
        <p className="sf-intro">
          Each room presents four cards—monsters, weapons, or potions. You must
          interact with three and choose one to carry forward to the next room.
          Limited health. Every choice is permanent.
        </p>

        <div className="sf-cards-grid">
          <StyledBorderView borderFolder="border" className="sf-feature-card">
            <div className="sf-feature-card-icons">
              <img
                src={`${baseUrl}/assets/subterra-fors-assets/images/icons/suites/clover.png`}
                alt=""
                className="sf-feature-card-icon"
              />
              <img
                src={`${baseUrl}/assets/subterra-fors-assets/images/icons/suites/spade.png`}
                alt=""
                className="sf-feature-card-icon"
              />
            </div>
            <p className="sf-feature-card-title">Monsters</p>
            <p className="sf-feature-card-desc">
              Deal damage. Choose wisely.
            </p>
          </StyledBorderView>
          <StyledBorderView borderFolder="border" className="sf-feature-card">
            <img
              src={`${baseUrl}/assets/subterra-fors-assets/images/icons/suites/diamond.png`}
              alt=""
              className="sf-feature-card-icon"
            />
            <p className="sf-feature-card-title">Weapons</p>
            <p className="sf-feature-card-desc">
              Reduce incoming damage.
            </p>
          </StyledBorderView>
          <StyledBorderView borderFolder="border" className="sf-feature-card">
            <img
              src={`${baseUrl}/assets/subterra-fors-assets/images/icons/suites/heart.png`}
              alt=""
              className="sf-feature-card-icon"
            />
            <p className="sf-feature-card-title">Potions</p>
            <p className="sf-feature-card-desc">Restore health, but only 1x a room.</p>
          </StyledBorderView>
        </div>
      </section>

      {/* Risk & Reward */}
      <section className="sf-risk-section">
        <StyledBorderView
          borderFolder="border"
          className="sf-risk-border-wrap"
          contentStyle={{ padding: "calc(23px + 2rem)" }}
        >
          <h2 className="sf-section-title sf-section-title-centered">
            Risk & Reward
          </h2>
          <p className="sf-risk-intro">
            Cards are drawn randomly.
          </p>

          <div className="sf-risk-rows">
          {/* Monsters (damage scales) - clovers + spades */}
          <div className="sf-risk-row sf-risk-row-monsters">
            <p className="sf-risk-row-label">Monsters · damage scales</p>
            <div className="sf-risk-row-cards-stack">
              <div className="sf-risk-row-cards">
                {["2", "5", "8", "k"].map((rank) => (
                  <img
                    key={`clover-${rank}`}
                    src={`${baseUrl}/assets/subterra-fors-assets/images/icons/clovers/${rank}.png`}
                    alt={`Monster rank ${rank}`}
                    className="sf-card sf-card-monster sf-card-monster-clover"
                  />
                ))}
              </div>
              <div className="sf-risk-row-cards">
                {["2", "5", "8", "k"].map((rank) => (
                  <img
                    key={`spade-${rank}`}
                    src={`${baseUrl}/assets/subterra-fors-assets/images/icons/spades/${rank}.png`}
                    alt={`Monster rank ${rank}`}
                    className="sf-card sf-card-monster sf-card-monster-spade"
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Weapons (protection scales) - diamonds */}
          <div className="sf-risk-row sf-risk-row-weapons">
            <p className="sf-risk-row-label">Weapons · protection scales</p>
            <div className="sf-risk-row-cards">
              {["2", "5", "8", "k"].map((rank) => (
                <img
                  key={`diamond-${rank}`}
                  src={`${baseUrl}/assets/subterra-fors-assets/images/icons/diamonds/${rank}.png`}
                  alt={`Weapon rank ${rank}`}
                  className="sf-card sf-card-weapon"
                />
              ))}
            </div>
          </div>

          {/* Healing - hearts */}
          <div className="sf-risk-row sf-risk-row-healing">
            <p className="sf-risk-row-label">Potions · healing scales</p>
            <div className="sf-risk-row-cards">
              {["2", "5", "8", "k"].map((rank) => (
                <img
                  key={`heart-${rank}`}
                  src={`${baseUrl}/assets/subterra-fors-assets/images/icons/hearts/${rank}.png`}
                  alt={`Healing rank ${rank}`}
                  className="sf-card sf-card-healing"
                />
              ))}
            </div>
          </div>
          </div>

          <p className="sf-risk-tagline">
            Higher cards hit harder — for you or against you.
          </p>
        </StyledBorderView>
      </section>

      {/* Footer */}
      <footer className="sf-footer">
        <div
          className="sf-footer-top-border"
          aria-hidden="true"
          style={{
            backgroundImage: `url("${baseUrl}/assets/subterra-fors-assets/images/border/top.png")`,
          }}
        />
        <p className="sf-footer-title">Subterra Fors</p>
        <p className="sf-footer-copy">
          © {new Date().getFullYear()} Bubbly Studios
        </p>
        <Link to="/subterrafors/privacy" className="sf-footer-link">
          Privacy
        </Link>
      </footer>
      </div>
    </div>
  )
}

export default SubterraFors
